<template>
    <div class="layout-main-container">
        <div class="layout-main">
            <MyPaginator ref="paginator" :rowsPerPage="pageSize" :totalRecords="totalUsersCount"
                @pageSelected="changePage" />
            <div style="margin-top: 20px;">
                <div v-for="u in users" :key="u" class="flex justify-content-center">
                    <div class="flex justify-content-center align-content-center user_container">
                        <div>
                            <img style="display: block;" :src="u.imageUrl" class="user_avatar"
                                @click="showUserInfo(u.id)" />
                        </div>
                        <div style="width: 6em;">
                            <p>
                                {{ u.rewardablePoints }} {{ i18n.t('POINT') }}
                            </p>
                        </div>
                        <div>
                            <Button :label="$t('REWARD')" @click="openReward(u)" />
                        </div>
                    </div>
                </div>
            </div>
            <Dialog v-model:visible="showRewardDialog" :modal="true" :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
                :style="{ width: '20vw' }">
                <template #header>
                    <div></div>
                </template>
                <div class="reward_dialog">
                    <label for="rewardPoints" style="font-weight: bold;">
                        {{ $t('REWARD_POINTS') }}
                    </label>
                    <div>
                        <InputNumber id="rewardPoints" class="reward_points" v-model="rewardPoints" :min="0" />
                    </div>
                    <label for="rewardComment" style="font-weight: bold;">
                        {{ $t('REWARD_COMMENT') }}
                    </label>
                    <div>
                        <Textarea id="rewardComment" v-model="rewardComment" rows="2"
                            style="width: 100%; direction: rtl;" />
                    </div>
                    <div>
                        <Button :label="$t('REWARD')" :disabled="!canReward" @click="reward" />
                    </div>
                </div>
            </Dialog>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onErrorCaptured, computed } from 'vue'
import { handleError } from '@/helpers/ErrorHandler'
import { useToast } from "primevue/usetoast"
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/stores/auth'
import { useDialog } from 'primevue/usedialog'
import MyPaginator from '@/components/MyPaginator.vue'
import UserOverview from '@/components/UserOverview.vue'
import userService from '@/service/UserService'
import { genericServerMessageEnum } from '@/helpers/Constants'

const dialog = useDialog()
const authStore = useAuthStore()
const toast = useToast()
const i18n = useI18n()

const totalUsersCount = ref(0)
const pageSize = 10

const users = ref([])

const showRewardDialog = ref(false)
const rewardPoints = ref(0)
const rewardComment = ref('')
let userToBeRewarded

onMounted(async () => {
    try {
        await loadPage(0)
    } catch (error) {
        handleError(authStore, toast, i18n, error)
    }
})

onErrorCaptured((err, instance, info) => {
    return handleError(authStore, toast, i18n, err, instance, info)
})

const loadPage = async (number) => {
    const response = await userService.getUsers(number, pageSize)
    users.value = response.collection
    totalUsersCount.value = response.total
}

// Events
const changePage = async (requestPage) => {
    await loadPage(requestPage)
}

const showUserInfo = (userId) => {
    dialog.open(UserOverview, {
        props: {
            header: i18n.t('USER_INFO'),
            style: {
                width: '20em',
            },
            breakpoints: {
                '960px': '75vw',
                '640px': '90vw'
            },
            modal: true
        },
        data: {
            userId: userId,
        }
    })
}

const openReward = (user) => {
    rewardPoints.value = 0
    rewardComment.value = ''
    userToBeRewarded = user
    showRewardDialog.value = true
}

const canReward = computed(() => {
    return rewardPoints.value > 0 && !!rewardComment.value &&
        userToBeRewarded.rewardablePoints >= rewardPoints.value
})


const reward = async () => {
    const response = await userService.rewardUser(userToBeRewarded, rewardPoints.value, rewardComment.value);
    if (response.message === genericServerMessageEnum.OK) {
        toast.add({ severity: 'info', summary: i18n.t('USER_REWARDED'), detail: '', life: 3000 })
        userToBeRewarded.rewardedPoints = response.result.rewardedPoints
        showRewardDialog.value = false
    }
}

</script>

<style scoped>
.user_avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
}

.user_container {
    margin-bottom: 10px;
    color: white;
    direction: rtl;
/* background: #edede8;*/    
    background: var(--blue-black-new-4);
    padding: 10px 20px;
    border-radius: 20px;
    box-shadow: 0 0 10px #435a8573;
}

.user_container>div {
    display: flex;
    justify-content: center;
    align-items: center;
}

.reward_dialog {
    text-align: center;
    margin-top: 10px;
}

.reward_dialog>div {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.reward_points:deep(.p-inputnumber-input) {
    text-align: center;
}

</style>